import * as React from 'react';
/**
 *
 * Original name: restore
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A524
 *
 */
export const RestoreSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M101 35a9.012 9.012 0 0 0-9-9H78v-4a9.01 9.01 0 0 0-9-9H51a9.01 9.01 0 0 0-9 9v4H28a9.01 9.01 0 0 0-9 9v8h8.352l6.806 54.344A11.014 11.014 0 0 0 45.076 107h29.848a11.013 11.013 0 0 0 10.917-9.65L92.648 43H101v-8ZM48 22a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4H48v-4Zm31.887 74.61a5.005 5.005 0 0 1-4.963 4.39H45.076a5.007 5.007 0 0 1-4.963-4.4L33.4 43h53.2l-6.713 53.61ZM95 37H25v-2a3 3 0 0 1 3-3h64a3 3 0 0 1 3 3v2Z", fill: "currentColor" }),
    React.createElement("path", { d: "M57 65.443V89h6V65.443a38.93 38.93 0 0 0 8.658 6.241l2.688-5.364C74.257 66.274 65.568 61.745 63 55h-6c-2.568 6.745-11.257 11.274-11.342 11.317l2.684 5.366A38.931 38.931 0 0 0 57 65.443Z", fill: "currentColor" })));
